import { render, staticRenderFns } from "./RoomStartMeeting.vue?vue&type=template&id=2938fd51&scoped=true"
import script from "./RoomStartMeeting.vue?vue&type=script&lang=js"
export * from "./RoomStartMeeting.vue?vue&type=script&lang=js"
import style0 from "./RoomStartMeeting.vue?vue&type=style&index=0&id=2938fd51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2938fd51",
  null
  
)

export default component.exports